




























































































import { Vue, Prop, Component, Watch, Inject } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { submitWork, setSubmissionStatus } from "@/services/api/submission";
import LoaderMixin from "@/mixins/loader";
import NotificationMixin from "@/mixins/notification";
import { getProofreadSummary } from "../../../services/api/proofreads";
import { setSubmissionProofreaders } from '../../../services/user';

@Component
export default class ProofreadsSummary extends mixins(
  LoaderMixin,
  NotificationMixin
) {
  @Prop({ type: Boolean, default: false }) showDialog: boolean;
  @Prop(Number) submissionId!: number;
  @Prop(String) status!: string;

  private dialog: boolean = false;
  private dialog2 = false;

  private toApprove = false;

  private summary = {};
  private title: string = "";

  @Watch("showDialog")
  showDialogChanged(newVal: boolean) {
    this.dialog = newVal;

    if (newVal) {
      this.loadData();
    }
  }

  private async loadData() {
    this.showLoader();
    try {
      this.summary = await getProofreadSummary(this.submissionId);

      this.hideLoader();
    } catch (error) {
      this.showErrorNotification("Ocorreu um erro ao carregar o resumo."); 
      this.hideLoader();
    }
  }

  private async setStatus() {

    try {
      await setSubmissionStatus(this.submissionId, this.toApprove ? "aprovado" : "reprovado");

      this.dialog2 = false;

    } catch (error) {
      this.dialog2 = false;
      this.showErrorNotification("Ocorreu um erro ao definir status do trabalho.");
    }

  }

  private hideDialog() {
    this.$emit("hidden");
  }
}
